import { Flex, Th } from "@chakra-ui/react";
import { BsPrinter } from "react-icons/bs";

export function UsageTh({ text, isPrint = false }) {
  return (
    <Th
      bg="#378BBF"
      color="#fff"
      textAlign={"center"}
      fontSize="11px"
      paddingInline=".3rem"
    >
      {isPrint && (
        <Flex alignItems="center" justifyContent="center" gap={2}>
          <BsPrinter size="25px" color="#fff" />
          {text}
        </Flex>
      )}
      {!isPrint && text}
    </Th>
  );
}
